module.exports = __webpack_public_path__ + "static/media/VISA-PROM-VAN.dff7b99d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/visa-prom/VISA-PROM-VAN.jpg
// module id = 453
// module chunks = 0